import { render, staticRenderFns } from "./org-table-paging-select.vue?vue&type=template&id=69f89f00&scoped=true"
import script from "./org-table-paging-select.vue?vue&type=script&lang=js"
export * from "./org-table-paging-select.vue?vue&type=script&lang=js"
import style0 from "./org-table-paging-select.vue?vue&type=style&index=0&id=69f89f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f89f00",
  null
  
)

export default component.exports